import { registerFunctionalComponent } from 'js/lib/components/component'
import { on } from 'js/lib/events'
import { CHECKOUT_CLEAR_ERROR_EVENT, CHECKOUT_ERROR_EVENT } from '../stripe_checkout/events'

registerFunctionalComponent('.js-c-payments-error', 'PaymentsError', initPaymentsError)

function initPaymentsError(component) {
  const checkoutRoot = component.element.closest('.js-c-payments-stripe-checkout')

  hideError(component.element)

  if (!checkoutRoot) return

  component.useHandler(() => on(CHECKOUT_CLEAR_ERROR_EVENT, checkoutRoot, () => hideError(component.element)))
  component.useHandler(() => on(CHECKOUT_ERROR_EVENT, checkoutRoot, event => handleCheckoutError(event, component.element)))
}

function handleCheckoutError(event, element) {
  const errorType = element.dataset.errorType

  if (errorType) {
    if (event.detail?.error_type !== errorType) {
      hideError(element)
      return
    }

    event.preventDefault()
    showConfiguredError(element, event.detail)
    return
  }

  if (event.defaultPrevented) {
    hideError(element)
    return
  }

  event.preventDefault()
  showFallbackError(element, event.detail)
}

function showError(element) {
  element.classList.remove('tw-hidden')
}

function showConfiguredError(element, detail) {
  setMessage(element, buildMessage(detail))
  showError(element)
}

function hideError(element) {
  setMessage(element, null)
  element.classList.add('tw-hidden')
}

function showFallbackError(element, detail) {
  setMessage(element, buildMessage(detail))
  showError(element)
}

function setMessage(element, message) {
  const messageElement = element.querySelector('.js-c-payments-error-message')

  if (messageElement) {
    messageElement.textContent = message || ''
    messageElement.classList.toggle('tw-hidden', !message)
  }

  if (!messageElement) return
}

function buildMessage(detail) {
  const errors = Array.isArray(detail?.errors) ? detail.errors.filter(Boolean) : []

  if (errors.length > 0) return errors.join('. ')
  if (detail?.message) return detail.message

  return null
}
